module.exports = __webpack_public_path__ + "static/media/cryptoearn-cropped2.954c81b2.png";